import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_PROMOTE_OR_SHARE_WHATSAPP_CHANNEL = defineFcm('psf_promote_or_share_whatsapp_channel')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'psf promote-or-share share slide-up',
		description:
			'Channel-aware PSF (WhatsApp): kill-switch + experiment binding for the "Send on WhatsApp" primary button shown on the promote_or_share share slide-up to WhatsApp-arrival signers.',
		deprecated:
			'Experiment binding replaced by FC psf_promote_or_share_channel_aware_cta (CHANGE-98150 productization) — front-end usage removed; safe to delete after 2026-09-14',
		template: {
			enabled: false,
			experimentName: 'psf_promote_or_share_whatsapp_channel_experiment',
		},
	});
